import InterviewHead from 'components/Interview/Head';
import { FC, useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import getInterviewNames from 'utils/getInterviewNames';
import { ReviewPageContext } from '.';

const Head: FC = () => {
  const { interview } = useContext(ReviewPageContext);
  const { id } = useParams();

  const names: { mentee: string; mentor: string } = useMemo(() => {
    return getInterviewNames(interview);
  }, [interview]);
  return (
    <InterviewHead
      title={`${names.mentor} (${names.mentee})`}
      backTo={`/admin/mentoring/mentors/${id}/interviews/`}
      interview={interview}
      variant="admin"
    />
  );
};

export default Head;
